module.exports = __webpack_public_path__ + "static/media/open-dropdown-icon.0799403a.svg";